import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

// Admin kiest de eerste stop; de rest wordt vanaf daar herberekend.
export const FirstStopSelect = ({ driver, date = '', refreshKey }) => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/admin/chauffeur-route-order/${driver}`, { params: { date }, headers: auth() })
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, [driver, date, refreshKey]);

  const choose = async (stopId) => {
    setBusy(true);
    try {
      const r = await axios.put(`${API}/admin/chauffeur-first-stop/${driver}`, { stop_id: stopId || null }, { params: { date }, headers: auth() });
      setData(r.data);
      const first = r.data.stops[0];
      toast.success(stopId
        ? `${driver}: start bij ${first?.company} · route herberekend (~${r.data.estimated_total_km} km)`
        : `${driver}: automatische route vanaf Schalkhaar`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Opslaan mislukt');
    } finally {
      setBusy(false);
    }
  };

  if (!data || data.stops.length === 0) return null;
  return (
    <label className="block mt-2">
      <span className="text-[10px] font-semibold uppercase text-zinc-600">Eerste stop</span>
      <select value={data.first_stop || ''} disabled={busy} onChange={(e) => choose(e.target.value)}
              className="w-full mt-0.5 text-xs px-1.5 py-1 border border-zinc-300 rounded bg-white disabled:opacity-50"
              data-testid={`first-stop-select-${driver}-${date}`}>
        <option value="">Automatisch (vanaf Schalkhaar)</option>
        {data.stops.map((s) => (
          <option key={s.stop_id} value={s.stop_id}>{s.company} ({s.motor_count})</option>
        ))}
      </select>
    </label>
  );
};
